export default __webpack_public_path__ + "static/media/sv_1.40a7dabf.jpg";